import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useQuery } from '@apollo/client'
import { useFormikContext, ErrorMessage } from 'formik'
import { Dropdown } from '../../Services/Payment/Components'
import { SAVED_USER_ADDRESSES } from '~queries/addresses'

const Main = styled.div`
  && ${Dropdown} {
    padding: 0 0 3px 5px;
  }
`

function UsedAddressesDropdown ({ fieldPrefix, formType, postalCodes, addressCallback }) {
  const { data: { myAddresses = [] } = {}, loading } = useQuery(SAVED_USER_ADDRESSES)

  let addresses = []
  const addressKey = `${fieldPrefix}Id`
  const { values } = useFormikContext()

  // Do something with address data after selection
  useEffect(() => {
    if (addressCallback) {
      const address = myAddresses.find(a => a.id === values[addressKey])
      addressCallback(address)
    }
  }, [values[addressKey]])

  if (['pick_up', 'delivery'].includes(formType)) {
    addresses = myAddresses.filter(a => postalCodes.map(p => p.id).includes(a.postalCode))
  } else {
    addresses = myAddresses
  }
  if (loading) return null
  return (
    <Main>
      <Dropdown component="select" name={addressKey} className="form-control">
        <option value="">Use a new address</option>
        {addresses.map(a => (
          <option key={a.id} value={a.id}>
            {a.street} {a.addressLine2}, {a.city}, {a.stateCode} {a.postalCode}
          </option>
        ))}
      </Dropdown>
    </Main>
  )
}

UsedAddressesDropdown.propTypes = {
  fieldPrefix: PropTypes.string.isRequired,
  formType: PropTypes.oneOf(['pick_up', 'delivery']),
  postalCodes: PropTypes.array,
  addressCallback: PropTypes.func
}

export default UsedAddressesDropdown
